module.exports = __webpack_public_path__ + "static/media/Graphic10.af35d606.png";